import { differenceInCalendarDays, differenceInHours, differenceInMinutes, format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
export const dateWithWeekday = date => {
  const options = {
    locale: de
  };
  const parsedDate = format(Date.parse(date), 'yyyy-MM-dd HH:mm', options);
  return format(parseISO(parsedDate), 'eee dd.MM.yyyy', options);
};
export const dateWithWeekdayFullName = date => {
  const options = {
    locale: de
  };
  const parsedDate = format(Date.parse(date), 'yyyy-MM-dd HH:mm', options);
  return format(parseISO(parsedDate), 'eeee dd.MM.yyyy', options);
};
// returns difference in HH:mm format
export const calculateFlightDuration = (departureTime, arrivalTime) => {
  const diffInHours = differenceInHours(new Date(departureTime), new Date(arrivalTime));
  const diffInMinutes = differenceInMinutes(new Date(departureTime), new Date(arrivalTime));
  const minutesLeft = diffInMinutes - diffInHours * 60;
  return `${diffInHours}h ${minutesLeft}min`;
};
export const dateTime = date => {
  const options = {
    locale: de
  };
  return format(Date.parse(date), 'HH:mm', options);
};
export const diffInCalendarDays = (departureTime, arrivalTime) => {
  return differenceInCalendarDays(new Date(arrivalTime), new Date(departureTime));
};